import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const MyFieldsYieldsIcon: React.FC<SvgProps> = ({
  strokeColor = '#CBD2D9',
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4221 9.55469H13.5324V30.7674H18.4221V9.55469Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M29.3333 1.18555H24.4437V30.7665H29.3333V1.18555Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M7.55633 18.3594H2.66669V30.8145H7.55633V18.3594Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M5.02087 26.1439L15.932 20.7434L26.979 6.97461"
      stroke={strokeColor}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default MyFieldsYieldsIcon;
